



































































































import {Component, Vue, Prop} from 'vue-property-decorator';
import {Mall} from '@/views/claim/dataType/OrderProductOption';
import ComponentNoticeBox from '@/views/claim/components/ComponentNoticeBox.vue';
import ComponentItemsClaim from '@/views/claim/components/ComponentItemsClaim.vue';
import ComponentProductExchange from '@/views/claim/components/ComponentProductExchange.vue';
import ComponentProductExchangeDetails from '@/views/claim/components/ComponentProductExchangeDetails.vue';
import ComponentProductDetails from '@/views/claim/components/ComponentProductDetails.vue';
import ComponentRefundExchangeAmount from '@/views/claim/components/ComponentRefundExchangeAmount.vue';
import ComponentBenefitsPaid from '@/views/claim/components/ComponentBenefitsPaid.vue';
import {ComponentItemsClaimDataType} from '@/views/claim/components/dataType/ComponentDataType';
import {
  CancelExchangesPredict,
  PostCancelExchangesPredictRequest,
  PostCancelExchangesRequest,
  AdditionalPayType,
  RefundType,
  GetClaimsOrderOptionsOrderOptionNoApply,
} from 'supporter';
@Component({
  components: {ComponentNoticeBox, ComponentItemsClaim, ComponentProductExchange, ComponentProductExchangeDetails, ComponentProductDetails, ComponentRefundExchangeAmount, ComponentBenefitsPaid}
})
export default class ExchangePopupBefore extends Vue {
  @Prop({required: true})
  private orderOptionsApply!: ComponentItemsClaimDataType;

  @Prop({required: true})
  private partnerNo!: string;

  @Prop({required: true})
  private memberNo!: string;

  @Prop({required: true})
  private mallNo!: string;

  @Prop({required: true})
  private claimOrderOptions!: GetClaimsOrderOptionsOrderOptionNoApply;

  @Prop({default: false})
  private escrowOrder!: boolean;

  private pageName: string = 'ExchangePopupBefore'; //
  private showA: boolean = true;
  private showB: boolean = true;
  private zeroRefundShow: boolean = false;
  private refundBankInfoTrShow: boolean = true;
  // private isSameMallProductNo:boolean = false
  private objJson = '';
  private displayedDeliveryAmtDiscountMessage: boolean = false;
  private mall: Mall = {
    countryCd: 'KR'
  };

  private postCancelExchangesPredict!: CancelExchangesPredict;
  public checkedExchangesProduct: boolean = false;
  private refundTypeDivShow: boolean = false;

  private initPostCancelExchangesPredict() {
    this.postCancelExchangesPredict = {
      refundType: 'ACCOUNT',
      shipping: {
        requiresShipping: true,
        address: {
          address: '',
          name: '',
          jibunAddress: '',
          detailAddress: '',
          zipCd: '',
          contact1: '',
          contact2: '',
        },
        shippingNo: 0,
        divided: false,
        deliveryGroupNo: 0,
        deliveryType: '',
        prepaid: true,
        deliveryTemplateNo: 0,
        combined: false,
        originalShippingNo: 0,
        hasAdjustedExchangeDeliveryAmt: true
      },
      coupon: {
        productCoupons: [],
        cartCoupon: {
          couponName: '',
          couponIssueNo: 0,
          orderProductNo: 0,
          restores: false,
          couponNo: 0,
        }
      },
      amounts: {
        deliveryAdjustAmt: 0,
        adjustedAmounts: {
          mainPayAmt: 0,
          accumulationPayAmt: 0,
          claimAmt: 0,
          additionalPayAmt: 0,
          payAmt: 0,
        },
        before: {
          delivery: {
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            deliveryGroupAmounts: {
              prepaidRemoteDeliveryAmt: 0,
              payOnRemoteDeliveryAmt: 0,
              deliveryAmt: 0,
              remoteDeliveryAmt: 0,
              payOnDeliveryAmt: 0,
              totalDeliveryAmt: 0,
              prepaidDeliveryAmt: 0,
              totalPrepaidDeliveryAmt: 0,
              alreadyPaidTotalDeliveryAmt: 0
            }
          },
          coupon: {
            cartCouponDiscountAmt: 0,
            productCouponDiscountAmt: 0,
          },
          accumulation: {
            accumulationAmt: 0,
          },
          order: {
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0,
            standardAmt: 0,
            mainPayAmt: 0,
            accumulationPayAmt: 0,
            remainingPgPayAmt: 0,
            payAmt: 0,
          }
        },
        productAdjustAmt: 0,
        after: {
          delivery: {
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            deliveryGroupAmounts: {
              prepaidRemoteDeliveryAmt: 0,
              payOnRemoteDeliveryAmt: 0,
              deliveryAmt: 0,
              remoteDeliveryAmt: 0,
              payOnDeliveryAmt: 0,
              totalDeliveryAmt: 0,
              prepaidDeliveryAmt: 0,
              totalPrepaidDeliveryAmt: 0,
              alreadyPaidTotalDeliveryAmt: 0
            }
          },
          coupon: {
            cartCouponDiscountAmt: 0,
            productCouponDiscountAmt: 0,
          },
          accumulation: {
            accumulationAmt: 0,
          },
          order: {
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0,
            standardAmt: 0,
            mainPayAmt: 0,
            accumulationPayAmt: 0,
            remainingPgPayAmt: 0,
            payAmt: 0,
          }
        },
        refund: {
          delivery: {
            deliveryAmt: 0,
            remoteDeliveryAmt: 0,
            totalDeliveryAmt: 0,
            deliveryGroupAmounts: {
              prepaidRemoteDeliveryAmt: 0,
              payOnRemoteDeliveryAmt: 0,
              deliveryAmt: 0,
              remoteDeliveryAmt: 0,
              payOnDeliveryAmt: 0,
              totalDeliveryAmt: 0,
              prepaidDeliveryAmt: 0,
              totalPrepaidDeliveryAmt: 0,
              alreadyPaidTotalDeliveryAmt: 0
            }
          },
          coupon: {
            cartCouponDiscountAmt: 0,
            productCouponDiscountAmt: 0,
          },
          accumulation: {
            accumulationAmt: 0,
          },
          order: {
            immediateDiscountAmt: 0,
            additionalDiscountAmt: 0,
            standardAmt: 0,
            mainPayAmt: 0,
            accumulationPayAmt: 0,
            remainingPgPayAmt: 0,
            payAmt: 0,
            cancelTotalPrice: 0,
            exchangeTotalPrice: 0,
            exchangeProductAmtAdjustAmt: 0,
            exchangeAddTotalPrice: 0,
            productCouponDiscountAmt: 0,
            totalPayAmt: 0,
            totalDeliveryAmt: 0,
            totalExchangeAmt: 0,
            freeGiftDiscountAmt: 0,
          }
        },
      },
      exchangeShipping: {
        address: {
          address: '',
          name: '',
          jibunAddress: '',
          detailAddress: '',
          zipCd: '',
          contact1: '',
          contact2: '',
        },
        divided: false,
        deliveryType: '',
        remoteDeliveryAmt: 0,
        prepaid: false,
        requiresShipping: false,
        deliveryAmt: 0,
        shippingNo: 0,
        returnDeliveryAmt: 0,
        deliveryGroupNo: 0,
        deliveryTemplateNo: 0,
        combined: false,
        originalShippingNo: 0,
      },
      overflowsPgAmt: false,
    }
    this.setFreeGiftDiscountAmt();
    this.objJson = JSON.stringify(this.postCancelExchangesPredict);
  }

  private created() {
    this.initPostCancelExchangesPredict();
  }

  private clearData() {
    this.initPostCancelExchangesPredict();
    this.$nextTick(() => {
      (this.$refs.componentProductExchangeDetails as any).exchangeProductAmtAdjustAmt = 0;
      (this.$refs.componentProductExchangeDetails as any).exchangeProductAmtAdjustReason = '';
      (this.$refs.componentProductExchangeDetails as any).defaultCalculation();
      this.freeGiftDiscountAmt = 0;
    });
    this.checkedExchangesProduct = false;
  }
  private accumulationUsed: boolean = false;
  private freeGiftDiscountAmt = 0;
  private setFreeGiftDiscountAmt() {
    this.freeGiftDiscountAmt = this.orderOptionsApply.claimableOptions[0].freeGiftDiscountAmt;
    // this.$set(this.postCancelExchangesPredict.amounts.refund.order, 'freeGiftDiscountAmt', this.orderOptionsApply.claimableOptions[0].freeGiftDiscountAmt);
  }
  private setData() {
    let exchangeOptionNo: number = (this.$refs.componentProductExchange as any).mallOptionValue;
    let exchangeCnt: number = (this.$refs.componentProductExchange as any).exchangeCnt;
    let cancelCnt: number =
      (this.$refs.componentItemsClaim as any).orderCntArry == null || (this.$refs.componentItemsClaim as any).orderCntArry == undefined || (this.$refs.componentItemsClaim as any).orderCntArry.length == 0
        ? 0
        : (this.$refs.componentItemsClaim as any).orderCntArry[0];

    this.setFreeGiftDiscountAmt();
    if (exchangeOptionNo != null && exchangeOptionNo != undefined && exchangeOptionNo != 0) {
      let request: PostCancelExchangesPredictRequest = {
        data: {
          cancelOrderOptionNo: Number(this.orderOptionsApply.claimableOptions[0].orderOptionNo),
          responsibleObjectType: (this.$refs.componentItemsClaim as any).responsibleObjectTypeValue,
          refundType: this.orderOptionsApply.refundTypes[0].refundType as RefundType,
          exchangeOptionNo: exchangeOptionNo,
          exchangeCnt: exchangeCnt,
          orderNo: this.orderOptionsApply.orderNo,
          cancelCnt: cancelCnt,
          sellerPaysClaimedDelivery: (this.$refs.componentProductDetails as any).chargeDeliveryAmt,
          productAdjustAmt: (this.$refs.componentProductExchangeDetails as any) == undefined ? 0 : (this.$refs.componentProductExchangeDetails as any).exchangeProductAmtAdjustAmt,
          exchangeProductNo: (this.$refs.componentProductExchange as any).mallProductNo
        }
      };
      this.$api.postCancelExchangesPredict(request).then((ret: any) => {
        this.postCancelExchangesPredict = ret.data;
        this.accumulationUsed = (this.$refs.componentProductExchange as any).accumulationUsed
        this.checkedExchangesProduct = true;
        this.refundTypeDivShow = this.postCancelExchangesPredict.amounts.adjustedAmounts.claimAmt < 0
        this.objJson = JSON.stringify(this.postCancelExchangesPredict);
      });
    } else {
      this.initPostCancelExchangesPredict();
    }
  }

  private close(): void {
    if(!confirm(this.$t('CLAIM_EXCHANGEPOPUP_CLOSECONFIRM').toString())) {
      return;
    }
    window.close();
  }

  private validation(): boolean {
    if ((this.$refs.componentProductExchangeDetails as any).exchangeProductAmtAdjustAmt > (this.$refs.componentProductExchangeDetails as any).orgTotalPayAmt) {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER5'));
      (this.$refs.componentProductExchangeDetails as any).exchangeProductAmtAdjustAmt = 0;
      (this.$refs.componentProductExchangeDetails as any).exchangeProductAmtAdjustReason = '';
      return false;
    }
    return true;
  }

  private checkHoldDelivery(): boolean {
    return this.orderOptionsApply.claimableOptions[this.orderOptionsApply.claimableOptions.length - 1].holdProcess == true && !confirm(this.$t('CLAIM_CANCELPOPUP_CONFIRM').toString());
  }

  private validationBeforeApply(): boolean {
    let exchangeProductAmtAdjustAmt: number = (this.$refs.componentProductExchangeDetails as any).exchangeProductAmtAdjustAmt;
    let exchangeProductAmtAdjustReason: string = (this.$refs.componentProductExchangeDetails as any).exchangeProductAmtAdjustReason;
    let refundType = '';
    if (exchangeProductAmtAdjustAmt > 0 && exchangeProductAmtAdjustReason == '') {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER6'));
      (this.$refs.componentProductExchangeDetails as any).$refs.exchangeProductAmtAdjustReasonRef.focus();
      return false;
    }

    if (this.postCancelExchangesPredict.amounts.adjustedAmounts.claimAmt == 0) {
      refundType = 'ZERO_REFUND';
    } else if ((this.$refs.componentRefundExchangeAmount as any).refundTypeValue == undefined || this.postCancelExchangesPredict.amounts.adjustedAmounts.claimAmt >= 0) {
      refundType = null;
    } else {
      refundType = (this.$refs.componentRefundExchangeAmount as any).refundTypeValue;
    }

    let needBankAccount = false;
    switch (refundType) {
      case 'CASH':
      case 'ACCOUNT':
        needBankAccount = true;
        break;
      case 'PG':
        if(this.orderOptionsApply.payType === 'VIRTUAL_ACCOUNT' || this.orderOptionsApply.payType === 'ESCROW_VIRTUAL_ACCOUNT') {
          needBankAccount = true;
        }
        break;
    }

    if (needBankAccount && (this.$refs.componentRefundExchangeAmount as any).refundBankValue == null) {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER7'));
      (this.$refs.componentRefundExchangeAmount as any).$refs.refundBankAccountRef.focus();
      return false;
    }

    if (needBankAccount && (this.$refs.componentRefundExchangeAmount as any).refundBankAccount == '') {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER8'));
      (this.$refs.componentRefundExchangeAmount as any).$refs.refundBankAccountRef.focus();
      return false;
    }

    if (needBankAccount && (this.$refs.componentRefundExchangeAmount as any).refundBankDepositorName == '') {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER9'));
      (this.$refs.componentRefundExchangeAmount as any).$refs.refundBankDepositorNameRef.focus();
      return false;
    }

    let exchangePayType = '';
    if (this.postCancelExchangesPredict.amounts.adjustedAmounts.claimAmt > 0) {
      exchangePayType = (this.$refs.componentRefundExchangeAmount as any).exchangePayType;
    }

    let needAdditionalPay: boolean = exchangePayType == 'CASH';

    let tradeBankAccountInfo = null;
    if (this.postCancelExchangesPredict.amounts.adjustedAmounts.claimAmt > 0) {
      let bankStringArr = String((this.$refs.componentRefundExchangeAmount as any).tradeBankAccountInfo).indexOf('|') >= 0 ? String((this.$refs.componentRefundExchangeAmount as any).tradeBankAccountInfo).split('|') : [null, null, null];
      tradeBankAccountInfo = {
        bank: bankStringArr[0],
        bankAccount: bankStringArr[1],
        bankDepositorName: bankStringArr[2]
      };
    }
    if (needAdditionalPay && (tradeBankAccountInfo == null || tradeBankAccountInfo.bank == null)) {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER10'));
      (this.$refs.componentRefundExchangeAmount as any).$refs.tradeBankAccountInfoRef.focus();
      return false;
    }

    let remitter = '';
    if (this.postCancelExchangesPredict.amounts.adjustedAmounts.claimAmt > 0) {
      remitter = (this.$refs.componentRefundExchangeAmount as any).remitter;
    }
    if (needAdditionalPay && remitter == '') {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER11'));
      (this.$refs.componentRefundExchangeAmount as any).$refs.remitterRef.focus();
      return false;
    }
    return true;
  }

  private onClickApplyExchange() {
    let exchangeOptionNo: number = (this.$refs.componentProductExchange as any).mallOptionValue;

    // if (!this.validation()) {
    //   return;
    // }

    if (exchangeOptionNo == null || exchangeOptionNo == undefined || exchangeOptionNo == 0) {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER4'));
      return;
    }

    if (this.postCancelExchangesPredict.overflowsPgAmt && (this.$refs.componentRefundExchangeAmount as any).refundTypeValue != 'ACCOUNT' && (this.$refs.componentRefundExchangeAmount as any).refundTypeValue != 'ACCUMULATION') {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_ALTER3'));
      return;
    }

    if (!this.validationBeforeApply()) {
      return;
    }

    if (this.checkHoldDelivery()) {
      return;
    }

    if (this.orderOptionsApply.payType === 'RENTAL') {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_RENTAL_ALERT').toString());
      return;
    }

    if (!confirm(this.$t('CLAIM_EXCHANGEPOPUP_CHANGE_CONFIRM').toString())) {
      return;
    }

    let exchangePayType: AdditionalPayType = null;
    if (this.postCancelExchangesPredict.amounts.adjustedAmounts.claimAmt > 0) {
      exchangePayType = (this.$refs.componentRefundExchangeAmount as any).exchangePayType;
    }

    let remitter = '';
    if (this.postCancelExchangesPredict.amounts.adjustedAmounts.claimAmt > 0 && exchangePayType === 'CASH') {
      remitter = (this.$refs.componentRefundExchangeAmount as any).remitter;
    }

    let tradeBankAccountInfo = null;
    if (this.postCancelExchangesPredict.amounts.adjustedAmounts.claimAmt > 0 && exchangePayType === 'CASH') {
      let bankStringArr = String((this.$refs.componentRefundExchangeAmount as any).tradeBankAccountInfo).indexOf('|') >= 0 ? String((this.$refs.componentRefundExchangeAmount as any).tradeBankAccountInfo).split('|') : [null, null, null];
      let bankNm = '';
      (this.$refs.componentRefundExchangeAmount as any).refundBankList.forEach((element: {value: string; name: string}) => {
        if (element.value == bankStringArr[0]) {
          bankNm = element.name;
        }
      });
      tradeBankAccountInfo = {
        bank: bankStringArr[0],
        bankName: bankNm,
        bankAccount: bankStringArr[1],
        bankDepositorName: bankStringArr[2]
      };
    } else {
      tradeBankAccountInfo = {
        bank: null,
        bankName: null,
        bankAccount: null,
        bankDepositorName: null
      };
    }

    let bank = '';
    let bankNm = '';
    if((this.$refs.componentRefundExchangeAmount as any).refundBankEditShow === false) {
      bank = null
      bankNm = null
    } else {
      bank = (this.$refs.componentRefundExchangeAmount as any).refundBankValue;
      (this.$refs.componentRefundExchangeAmount as any).refundBankList.forEach((element: {value: string; name: string}) => {
        if (element.value == (this.$refs.componentRefundExchangeAmount as any).refundBankValue) {
          bankNm = element.name;
        }
      });
    }

    let refundType = '';
    if (this.postCancelExchangesPredict.amounts.adjustedAmounts.claimAmt == 0) {
      refundType = 'ZERO_REFUND';
    } else if ((this.$refs.componentRefundExchangeAmount as any).refundTypeValue == undefined || this.postCancelExchangesPredict.amounts.adjustedAmounts.claimAmt >= 0) {
      refundType = null;
    } else {
      refundType = (this.$refs.componentRefundExchangeAmount as any).refundTypeValue;
    }

	  this.alertMessageForFreeGift();

    let request: PostCancelExchangesRequest = {
      data: {
        productAdjustReason: (this.$refs.componentProductExchangeDetails as any).exchangeProductAmtAdjustReason,
        additionalPayRemitter: remitter,
        reasonDetail: (this.$refs.componentItemsClaim as any).claimReasonDetail,
        additionalPayBankAccount: {
          depositorName: tradeBankAccountInfo.bankDepositorName,
          bank: tradeBankAccountInfo.bank,
          bankName: tradeBankAccountInfo.bankName,
          account: tradeBankAccountInfo.bankAccount
        },
        additionalPayType: exchangePayType,
        calculateParam: {
          refundType: refundType as any,
          cancelOrderOptionNo: Number(this.orderOptionsApply.claimableOptions[0].orderOptionNo),
          responsibleObjectType: (this.$refs.componentItemsClaim as any).responsibleObjectTypeValue,
          exchangeOptionNo: (this.$refs.componentProductExchange as any).mallOptionValue,
          exchangeCnt: (this.$refs.componentProductExchange as any).exchangeCnt,
          orderNo: this.orderOptionsApply.orderNo,
          cancelCnt:
            (this.$refs.componentItemsClaim as any).orderCntArry == null || (this.$refs.componentItemsClaim as any).orderCntArry == undefined || (this.$refs.componentItemsClaim as any).orderCntArry.length == 0
              ? 0
              : (this.$refs.componentItemsClaim as any).orderCntArry[0],
          sellerPaysClaimedDelivery: (this.$refs.componentProductDetails as any).chargeDeliveryAmt,
          productAdjustAmt: (this.$refs.componentProductExchangeDetails as any) == undefined ? 0 : (this.$refs.componentProductExchangeDetails as any).exchangeProductAmtAdjustAmt,
          exchangeProductNo: (this.$refs.componentProductExchange as any).mallProductNo
        },
        reasonType: (this.$refs.componentItemsClaim as any).claimReasonType,
        refundBankAccount: {
          depositorName: (this.$refs.componentRefundExchangeAmount as any).refundBankDepositorName,
          bank: bank,
          bankName: bankNm,
          account: (this.$refs.componentRefundExchangeAmount as any).refundBankAccount
        },

        // 교환시 구매자 입력값
        purchaserInputs: (this.$refs.componentProductExchange as any).mallInputs.map((purchaserInput, idx) => {
          return {
            inputLabel: purchaserInput.inputText,
            inputValue: (this.$refs.componentProductExchange as any).listMallInput[idx],
          }
        })
      }
    };

    this.$api.postCancelExchanges(request).then((): any => {
      alert(this.$t('CLAIM_EXCHANGEPOPUP_PROCESS_SUCCESS_MESSAGE'));
      window.opener.location.reload();
      window.close();
    });
  }

	private alertMessageForFreeGift() {

		const hasTargetProduct = this.orderOptionsApply.claimableOptions.some(option => (option as any ).isGivenFreeGift);
		if (hasTargetProduct) {
			alert('사은품이 지급된 대상상품이 포함되어있습니다. \n사은품 지급 철회가 필요한 경우 \n사은품 상품도 클레임 처리해 주세요.');
			return;
		}

		const hasFreeGiftProduct = this.orderOptionsApply.claimableOptions.some(option => (option as any).isFreeGift);
		if (hasFreeGiftProduct) {
			alert('사은품 상품이 포함되어 있습니다. \n사은품 지급 대상상품의 클레임 처리가 필요한 경우 \n별도 처리해 주세요.');
		}
	}


	public getPayType(payType: string) {
    switch (payType) {
      case 'ACCOUNT':
        return 'ACCOUNT'

      case 'ACCUMULATION':
        return 'ACCUMULATION'

      case 'ZERO_PAY':
        return 'ZERO_REFUND'

      case 'VIRTUAL_ACCOUNT':
      case 'ESCROW_VIRTUAL_ACCOUNT':
        return 'PG';

      default:
        return 'PG';
    }
  }
}
